import { BrandLogo } from "@/components/auth/BrandLogo";
import { useThemeCustomization } from "@/hooks/useThemeCustomization";
import { useTranslation } from "react-i18next";


export default function ForceUpdatePage() {
  const { t } = useTranslation("appui");
  const { brandName, appleStoreLink, playStoreLink } = useThemeCustomization();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 p-6 text-center">
      <BrandLogo />

      <div className="max-w-md w-full bg-white shadow-lg rounded-lg p-6 mt-8">
        <h1 className="text-2xl font-bold mb-4 text-gray-800">
          {t("forceUpdate.title")}
        </h1>
        <p className="mb-6 text-base text-gray-600">
          {t("forceUpdate.descriptionPart1")} <b>{brandName}</b>, {t("forceUpdate.descriptionPart2")}<br />
          {t("forceUpdate.descriptionPart3")}
        </p>

        <div className="flex flex-col sm:flex-row gap-4 mt-6">
          <a
            href={appleStoreLink}
            target="_blank"
            rel="noopener noreferrer"
            className="flex-1 h-20 bg-black rounded-xl overflow-hidden flex items-center justify-center hover:bg-gray-900 transition"
          >
            <img
              src="/lovable-uploads/app_store_badge.svg"
              alt={t("forceUpdate.appStoreAlt")}
              className="w-full h-full object-contain p-3"
            />
          </a>

          <a
            href={playStoreLink}
            target="_blank"
            rel="noopener noreferrer"
            className="flex-1 h-20 bg-green-600 rounded-xl overflow-hidden flex items-center justify-center hover:bg-green-700 transition"
          >
            <img
              src="/lovable-uploads/google-play-badge.png"
              alt={t("forceUpdate.playStoreAlt")}
              className="play-badge"
            />
          </a>
        </div>

        <div className="mt-8 text-red-600 text-md font-semibold">
          <span>{t("forceUpdate.blockedMessage")}</span>
        </div>
      </div>
    </div>
  );
}
